module.exports = __webpack_public_path__ + "img/Default Subpackage.30855e58.jpg";